const state = {
  isCollapsed: false,
  isMobile: false,
  openedPages: []
}

const mutations = {
  TOGGLE_COLLAPSE(state) {
    state.isCollapsed = !state.isCollapsed
  },
  SET_COLLAPSE(state, val) {
    state.isCollapsed = val
  },
  SET_MOBILE(state, val) {
    state.isMobile = val
  },
  ADD_OPENED_PAGE(state, page) {
    if (!state.openedPages.find(p => p.path === page.path)) {
      state.openedPages.push(page)
    }
  },
  REMOVE_OPENED_PAGE(state, path) {
    state.openedPages = state.openedPages.filter(p => p.path !== path)
  },
  SET_OPENED_PAGES(state, pages) {
    state.openedPages = pages
  }
}

// 完整菜单结构
const menuList = [
  {
    path: '/',
    title: '首页',
    icon: 'md-home'
  },
  {
    path: '/product',
    title: '商品管理',
    icon: 'md-cube',
    children: [
      { path: 'product_list', title: '商品列表', icon: 'md-list' },
      { path: 'product_classify', title: '商品分类', icon: 'md-folder' },
      { path: 'product_specs', title: '商品规格', icon: 'md-options' },
      { path: 'product_attr', title: '商品属性', icon: 'md-pricetags' },
      { path: 'product_brand', title: '品牌管理', icon: 'md-star' }
    ]
  },
  {
    path: '/order',
    title: '订单管理',
    icon: 'md-cart',
    children: [
      { path: 'list', title: '订单列表', icon: 'md-reorder' },
      { path: 'offline', title: '线下订单', icon: 'md-phone-portrait' },
      { path: 'refund', title: '退款订单', icon: 'md-return-left' },
      { path: 'invoice/list', title: '发票管理', icon: 'md-document' }
    ]
  },
  {
    path: '/user',
    title: '用户管理',
    icon: 'md-people',
    children: [
      { path: 'list', title: '用户列表', icon: 'md-contacts' },
      { path: 'level', title: '等级管理', icon: 'md-trophy' },
      { path: 'label', title: '用户标签', icon: 'md-pricetag' }
    ]
  },
  {
    path: '/finance',
    title: '财务管理',
    icon: 'md-card',
    children: [
      { path: 'capital/index', title: '资金流水', icon: 'md-cash' },
      { path: 'bill/index', title: '账单管理', icon: 'md-paper' },
      { path: 'cash/index', title: '提现管理', icon: 'md-wallet' },
      { path: 'finance/set', title: '财务设置', icon: 'md-settings' }
    ]
  },
  {
    path: '/marketing',
    title: '营销管理',
    icon: 'md-megaphone',
    children: [
      { path: 'coupon', title: '优惠券', icon: 'md-pricetag' },
      { path: 'promotion', title: '促销活动', icon: 'md-flash' },
      { path: 'lottery', title: '抽奖活动', icon: 'md-gift' },
      { path: 'pointProduct', title: '积分商品', icon: 'md-star-outline' }
    ]
  },
  {
    path: '/content',
    title: '内容管理',
    icon: 'md-document',
    children: [
      { path: 'article', title: '文章管理', icon: 'md-paper' },
      { path: 'page', title: '页面管理', icon: 'md-browsers' }
    ]
  },
  {
    path: '/community',
    title: '社区管理',
    icon: 'md-chatbubbles',
    children: [
      { path: 'topic', title: '社区话题', icon: 'md-chatboxes' },
      { path: 'content', title: '社区内容', icon: 'md-images' },
      { path: 'comment', title: '社区评论', icon: 'md-text' },
      { path: 'setting', title: '社区设置', icon: 'md-settings' }
    ]
  },
  {
    path: '/store',
    title: '门店管理',
    icon: 'md-pin',
    children: [
      { path: 'list', title: '门店列表', icon: 'md-locate' },
      { path: 'apply', title: '入驻申请', icon: 'md-clipboard' }
    ]
  },
  {
    path: '/stockManage',
    title: '库存管理',
    icon: 'md-archive',
    children: [
      { path: 'inbound', title: '入库管理', icon: 'md-arrow-down' },
      { path: 'outbound', title: '出库管理', icon: 'md-arrow-up' },
      { path: 'inventory', title: '库存盘点', icon: 'md-checkmark-circle' }
    ]
  },
  {
    path: '/supplier',
    title: '供应商',
    icon: 'md-train',
    children: [
      { path: 'index', title: '供应商列表', icon: 'md-people' },
      { path: 'orderList/index', title: '供应商订单', icon: 'md-list' }
    ]
  },
  {
    path: '/kefu',
    title: '客服管理',
    icon: 'md-headset',
    children: [
      { path: 'list', title: '客服列表', icon: 'md-people' },
      { path: 'chat', title: '聊天记录', icon: 'md-chatboxes' }
    ]
  },
  {
    path: '/statistic',
    title: '数据统计',
    icon: 'md-stats',
    children: [
      { path: 'user', title: '用户统计', icon: 'md-people' },
      { path: 'trade', title: '交易统计', icon: 'md-swap' },
      { path: 'product', title: '商品统计', icon: 'md-cube' }
    ]
  },
  {
    path: '/system',
    title: '系统设置',
    icon: 'md-cog',
    children: [
      { path: 'config', title: '系统设置', icon: 'md-settings' },
      { path: 'user', title: '管理员管理', icon: 'md-person' },
      { path: 'role', title: '角色管理', icon: 'md-contacts' },
      { path: 'menu', title: '权限菜单', icon: 'md-menu' },
      { path: 'log', title: '系统日志', icon: 'md-time' }
    ]
  }
]

const getters = {
  menuList: () => menuList
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
